/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { shopifyAppControllerDeleteSession } from '../fn/shopify-app/shopify-app-controller-delete-session';
import { ShopifyAppControllerDeleteSession$Params } from '../fn/shopify-app/shopify-app-controller-delete-session';
import { shopifyAppControllerDeleteSessions } from '../fn/shopify-app/shopify-app-controller-delete-sessions';
import { ShopifyAppControllerDeleteSessions$Params } from '../fn/shopify-app/shopify-app-controller-delete-sessions';
import { shopifyAppControllerFindSessions } from '../fn/shopify-app/shopify-app-controller-find-sessions';
import { ShopifyAppControllerFindSessions$Params } from '../fn/shopify-app/shopify-app-controller-find-sessions';
import { shopifyAppControllerGet } from '../fn/shopify-app/shopify-app-controller-get';
import { ShopifyAppControllerGet$Params } from '../fn/shopify-app/shopify-app-controller-get';
import { shopifyAppControllerGetSession } from '../fn/shopify-app/shopify-app-controller-get-session';
import { ShopifyAppControllerGetSession$Params } from '../fn/shopify-app/shopify-app-controller-get-session';
import { shopifyAppControllerGetStoreId } from '../fn/shopify-app/shopify-app-controller-get-store-id';
import { ShopifyAppControllerGetStoreId$Params } from '../fn/shopify-app/shopify-app-controller-get-store-id';
import { shopifyAppControllerLinkStoreSession } from '../fn/shopify-app/shopify-app-controller-link-store-session';
import { ShopifyAppControllerLinkStoreSession$Params } from '../fn/shopify-app/shopify-app-controller-link-store-session';
import { shopifyAppControllerLogGdprRequest } from '../fn/shopify-app/shopify-app-controller-log-gdpr-request';
import { ShopifyAppControllerLogGdprRequest$Params } from '../fn/shopify-app/shopify-app-controller-log-gdpr-request';
import { shopifyAppControllerRestoreAdmin } from '../fn/shopify-app/shopify-app-controller-restore-admin';
import { ShopifyAppControllerRestoreAdmin$Params } from '../fn/shopify-app/shopify-app-controller-restore-admin';
import { shopifyAppControllerSendWelcomeEmail } from '../fn/shopify-app/shopify-app-controller-send-welcome-email';
import { ShopifyAppControllerSendWelcomeEmail$Params } from '../fn/shopify-app/shopify-app-controller-send-welcome-email';
import { shopifyAppControllerSetPixelStatus } from '../fn/shopify-app/shopify-app-controller-set-pixel-status';
import { ShopifyAppControllerSetPixelStatus$Params } from '../fn/shopify-app/shopify-app-controller-set-pixel-status';
import { shopifyAppControllerUninstall } from '../fn/shopify-app/shopify-app-controller-uninstall';
import { ShopifyAppControllerUninstall$Params } from '../fn/shopify-app/shopify-app-controller-uninstall';
import { shopifyAppControllerUpsertSession } from '../fn/shopify-app/shopify-app-controller-upsert-session';
import { ShopifyAppControllerUpsertSession$Params } from '../fn/shopify-app/shopify-app-controller-upsert-session';
import { ShopifyAppSessionDto } from '../models/shopify-app-session-dto';
import { ShopifyAppStoredSessionDto } from '../models/shopify-app-stored-session-dto';
import { ShopifyStoreIdDto } from '../models/shopify-store-id-dto';

@Injectable({ providedIn: 'root' })
export class PlatformShopifyAppService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `shopifyAppControllerGetSession()` */
  static readonly ShopifyAppControllerGetSessionPath =
    '/api/v1/shopify-app/sessions/{shopifySessionId}';

  /**
   * Get one Shopify session by id. Server-to-server (api-key).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopifyAppControllerGetSession()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopifyAppControllerGetSession$Response(
    params: ShopifyAppControllerGetSession$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ShopifyAppStoredSessionDto>> {
    const obs = shopifyAppControllerGetSession(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get one Shopify session by id. Server-to-server (api-key).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopifyAppControllerGetSession$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopifyAppControllerGetSession(
    params: ShopifyAppControllerGetSession$Params,
    context?: HttpContext
  ): Observable<ShopifyAppStoredSessionDto> {
    const resp = this.shopifyAppControllerGetSession$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShopifyAppStoredSessionDto>): ShopifyAppStoredSessionDto => r.body)
    );
  }

  /** Path part for operation `shopifyAppControllerUpsertSession()` */
  static readonly ShopifyAppControllerUpsertSessionPath =
    '/api/v1/shopify-app/sessions/{shopifySessionId}';

  /**
   * Create or update a Shopify session. storeId/domains are platform-owned and never overwritten. Server-to-server (api-key).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopifyAppControllerUpsertSession()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopifyAppControllerUpsertSession$Response(
    params: ShopifyAppControllerUpsertSession$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ShopifyAppStoredSessionDto>> {
    const obs = shopifyAppControllerUpsertSession(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create or update a Shopify session. storeId/domains are platform-owned and never overwritten. Server-to-server (api-key).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopifyAppControllerUpsertSession$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopifyAppControllerUpsertSession(
    params: ShopifyAppControllerUpsertSession$Params,
    context?: HttpContext
  ): Observable<ShopifyAppStoredSessionDto> {
    const resp = this.shopifyAppControllerUpsertSession$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShopifyAppStoredSessionDto>): ShopifyAppStoredSessionDto => r.body)
    );
  }

  /** Path part for operation `shopifyAppControllerDeleteSession()` */
  static readonly ShopifyAppControllerDeleteSessionPath =
    '/api/v1/shopify-app/sessions/{shopifySessionId}';

  /**
   * Delete one Shopify session by id. Server-to-server (api-key).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopifyAppControllerDeleteSession()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopifyAppControllerDeleteSession$Response(
    params: ShopifyAppControllerDeleteSession$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const obs = shopifyAppControllerDeleteSession(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete one Shopify session by id. Server-to-server (api-key).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopifyAppControllerDeleteSession$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopifyAppControllerDeleteSession(
    params: ShopifyAppControllerDeleteSession$Params,
    context?: HttpContext
  ): Observable<void> {
    const resp = this.shopifyAppControllerDeleteSession$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `shopifyAppControllerFindSessions()` */
  static readonly ShopifyAppControllerFindSessionsPath = '/api/v1/shopify-app/sessions';

  /**
   * List Shopify sessions for a shop domain. Server-to-server (api-key).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopifyAppControllerFindSessions()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopifyAppControllerFindSessions$Response(
    params?: ShopifyAppControllerFindSessions$Params,
    context?: HttpContext
  ): Observable<
    StrictHttpResponse<{
      data?: Array<ShopifyAppStoredSessionDto>;
      hasMore?: boolean;
    }>
  > {
    const obs = shopifyAppControllerFindSessions(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List Shopify sessions for a shop domain. Server-to-server (api-key).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopifyAppControllerFindSessions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopifyAppControllerFindSessions(
    params?: ShopifyAppControllerFindSessions$Params,
    context?: HttpContext
  ): Observable<{
    data?: Array<ShopifyAppStoredSessionDto>;
    hasMore?: boolean;
  }> {
    const resp = this.shopifyAppControllerFindSessions$Response(params, context);
    return resp.pipe(
      map(
        (
          r: StrictHttpResponse<{
            data?: Array<ShopifyAppStoredSessionDto>;
            hasMore?: boolean;
          }>
        ): {
          data?: Array<ShopifyAppStoredSessionDto>;
          hasMore?: boolean;
        } => r.body
      )
    );
  }

  /** Path part for operation `shopifyAppControllerDeleteSessions()` */
  static readonly ShopifyAppControllerDeleteSessionsPath = '/api/v1/shopify-app/sessions';

  /**
   * Delete Shopify sessions by ids or by shop domain. Server-to-server (api-key).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopifyAppControllerDeleteSessions()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopifyAppControllerDeleteSessions$Response(
    params?: ShopifyAppControllerDeleteSessions$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const obs = shopifyAppControllerDeleteSessions(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete Shopify sessions by ids or by shop domain. Server-to-server (api-key).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopifyAppControllerDeleteSessions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopifyAppControllerDeleteSessions(
    params?: ShopifyAppControllerDeleteSessions$Params,
    context?: HttpContext
  ): Observable<void> {
    const resp = this.shopifyAppControllerDeleteSessions$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `shopifyAppControllerGet()` */
  static readonly ShopifyAppControllerGetPath = '/api/v1/shopify-app';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopifyAppControllerGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopifyAppControllerGet$Response(
    params?: ShopifyAppControllerGet$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ShopifyAppSessionDto>> {
    const obs = shopifyAppControllerGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopifyAppControllerGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopifyAppControllerGet(
    params?: ShopifyAppControllerGet$Params,
    context?: HttpContext
  ): Observable<ShopifyAppSessionDto> {
    const resp = this.shopifyAppControllerGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShopifyAppSessionDto>): ShopifyAppSessionDto => r.body)
    );
  }

  /** Path part for operation `shopifyAppControllerGetStoreId()` */
  static readonly ShopifyAppControllerGetStoreIdPath = '/api/v1/shopify-app/store-id';

  /**
   * Resolve the Terrific store linked to a Shopify shop: session storage first, then stores.externalUrl. Server-to-server (api-key).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopifyAppControllerGetStoreId()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopifyAppControllerGetStoreId$Response(
    params: ShopifyAppControllerGetStoreId$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ShopifyStoreIdDto>> {
    const obs = shopifyAppControllerGetStoreId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Resolve the Terrific store linked to a Shopify shop: session storage first, then stores.externalUrl. Server-to-server (api-key).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopifyAppControllerGetStoreId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopifyAppControllerGetStoreId(
    params: ShopifyAppControllerGetStoreId$Params,
    context?: HttpContext
  ): Observable<ShopifyStoreIdDto> {
    const resp = this.shopifyAppControllerGetStoreId$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<ShopifyStoreIdDto>): ShopifyStoreIdDto => r.body));
  }

  /** Path part for operation `shopifyAppControllerLinkStoreSession()` */
  static readonly ShopifyAppControllerLinkStoreSessionPath = '/api/v1/shopify-app/link-session';

  /**
   * Link a newly created Terrific store onto the Shopify session-storage record(s) for a shop. Idempotent.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopifyAppControllerLinkStoreSession()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopifyAppControllerLinkStoreSession$Response(
    params: ShopifyAppControllerLinkStoreSession$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const obs = shopifyAppControllerLinkStoreSession(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Link a newly created Terrific store onto the Shopify session-storage record(s) for a shop. Idempotent.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopifyAppControllerLinkStoreSession$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopifyAppControllerLinkStoreSession(
    params: ShopifyAppControllerLinkStoreSession$Params,
    context?: HttpContext
  ): Observable<void> {
    const resp = this.shopifyAppControllerLinkStoreSession$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `shopifyAppControllerLogGdprRequest()` */
  static readonly ShopifyAppControllerLogGdprRequestPath = '/api/v1/shopify-app/gdpr-requests';

  /**
   * Persist a Shopify mandatory privacy webhook payload. Server-to-server (api-key).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopifyAppControllerLogGdprRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopifyAppControllerLogGdprRequest$Response(
    params: ShopifyAppControllerLogGdprRequest$Params,
    context?: HttpContext
  ): Observable<
    StrictHttpResponse<{
      id?: string;
    }>
  > {
    const obs = shopifyAppControllerLogGdprRequest(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Persist a Shopify mandatory privacy webhook payload. Server-to-server (api-key).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopifyAppControllerLogGdprRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopifyAppControllerLogGdprRequest(
    params: ShopifyAppControllerLogGdprRequest$Params,
    context?: HttpContext
  ): Observable<{
    id?: string;
  }> {
    const resp = this.shopifyAppControllerLogGdprRequest$Response(params, context);
    return resp.pipe(
      map(
        (
          r: StrictHttpResponse<{
            id?: string;
          }>
        ): {
          id?: string;
        } => r.body
      )
    );
  }

  /** Path part for operation `shopifyAppControllerRestoreAdmin()` */
  static readonly ShopifyAppControllerRestoreAdminPath = '/api/v1/shopify-app/restore-admin';

  /**
   * Assign the given user (the Shopify app installer) as store admin. Idempotent. Server-to-server (api-key), used when installing on a shop that already has a Terrific store.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopifyAppControllerRestoreAdmin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopifyAppControllerRestoreAdmin$Response(
    params: ShopifyAppControllerRestoreAdmin$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const obs = shopifyAppControllerRestoreAdmin(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Assign the given user (the Shopify app installer) as store admin. Idempotent. Server-to-server (api-key), used when installing on a shop that already has a Terrific store.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopifyAppControllerRestoreAdmin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopifyAppControllerRestoreAdmin(
    params: ShopifyAppControllerRestoreAdmin$Params,
    context?: HttpContext
  ): Observable<void> {
    const resp = this.shopifyAppControllerRestoreAdmin$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `shopifyAppControllerSendWelcomeEmail()` */
  static readonly ShopifyAppControllerSendWelcomeEmailPath = '/api/v1/shopify-app/welcome-email';

  /**
   * Send the Shopify app welcome email once per install (reset on uninstall). Server-to-server (api-key).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopifyAppControllerSendWelcomeEmail()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopifyAppControllerSendWelcomeEmail$Response(
    params: ShopifyAppControllerSendWelcomeEmail$Params,
    context?: HttpContext
  ): Observable<
    StrictHttpResponse<{
      status?: 'queued' | 'already-sent';
    }>
  > {
    const obs = shopifyAppControllerSendWelcomeEmail(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Send the Shopify app welcome email once per install (reset on uninstall). Server-to-server (api-key).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopifyAppControllerSendWelcomeEmail$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopifyAppControllerSendWelcomeEmail(
    params: ShopifyAppControllerSendWelcomeEmail$Params,
    context?: HttpContext
  ): Observable<{
    status?: 'queued' | 'already-sent';
  }> {
    const resp = this.shopifyAppControllerSendWelcomeEmail$Response(params, context);
    return resp.pipe(
      map(
        (
          r: StrictHttpResponse<{
            status?: 'queued' | 'already-sent';
          }>
        ): {
          status?: 'queued' | 'already-sent';
        } => r.body
      )
    );
  }

  /** Path part for operation `shopifyAppControllerSetPixelStatus()` */
  static readonly ShopifyAppControllerSetPixelStatusPath = '/api/v1/shopify-app/pixel-status';

  /**
   * Record whether the Shopify app web pixel is active (app embed enabled) on the store integration. Server-to-server (api-key).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopifyAppControllerSetPixelStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopifyAppControllerSetPixelStatus$Response(
    params: ShopifyAppControllerSetPixelStatus$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const obs = shopifyAppControllerSetPixelStatus(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Record whether the Shopify app web pixel is active (app embed enabled) on the store integration. Server-to-server (api-key).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopifyAppControllerSetPixelStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopifyAppControllerSetPixelStatus(
    params: ShopifyAppControllerSetPixelStatus$Params,
    context?: HttpContext
  ): Observable<void> {
    const resp = this.shopifyAppControllerSetPixelStatus$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `shopifyAppControllerUninstall()` */
  static readonly ShopifyAppControllerUninstallPath = '/api/v1/shopify-app/uninstall';

  /**
   * Tear down store admin claims/managers, clear shopifyApp on the store and its integration, delete the shop sessions when the Shopify app is uninstalled. Server-to-server (api-key). The store and its content are kept.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopifyAppControllerUninstall()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopifyAppControllerUninstall$Response(
    params: ShopifyAppControllerUninstall$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const obs = shopifyAppControllerUninstall(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Tear down store admin claims/managers, clear shopifyApp on the store and its integration, delete the shop sessions when the Shopify app is uninstalled. Server-to-server (api-key). The store and its content are kept.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopifyAppControllerUninstall$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopifyAppControllerUninstall(
    params: ShopifyAppControllerUninstall$Params,
    context?: HttpContext
  ): Observable<void> {
    const resp = this.shopifyAppControllerUninstall$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }
}
